module.exports = __webpack_public_path__ + "media/images/extension-onboarding/arrow-left-89ad3e58bdb047554c8f4be00abb14a9.png";